/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Room_MeetingInputs */

const en_of_room_meeting = /** @type {(inputs: Of_Room_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting room`)
};

const id_of_room_meeting = /** @type {(inputs: Of_Room_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang rapat`)
};

/**
* | output |
* | --- |
* | "Meeting room" |
*
* @param {Of_Room_MeetingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_room_meeting = /** @type {((inputs?: Of_Room_MeetingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Room_MeetingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_room_meeting(inputs)
	return en_of_room_meeting(inputs)
});